riot.tag2('bbc-notifications-list', '<div if="{!opts.notifications.length}" id="no-notifications" class="no-notifications"> <div class="noVariant--element"> <p class="notifications-long-primer"><i1-8n>copy.noNotifications1</i1-8n></p> <p class="notifications-long-primer"><i1-8n>copy.noNotifications2</i1-8n></p> </div> <div class="variantProductLinks--element variantAddTopic--element"> <div id="no-notifications-no-subscriptions" if="{!opts.subscriptionCount}"> <p class="notifications-long-primer">Start adding to get notifications. Here are some places to add stuff you love.</p> <ul class="notifications-long-primer"> <li><a class="notifications-long-primer" href="{this.links.iplayer}" onclick="{this.logClickUpsell(\'iplayer\')}">iPlayer</a></li> <li>|</li> <li><a class="notifications-long-primer" href="{this.links.musicArtists}" onclick="{this.logClickUpsell(\'music-artists\')}">Music Artists</a></li> <li>|</li> <li><a class="notifications-long-primer" href="{this.links.musicPlaylists}" onclick="{this.logClickUpsell(\'music-playlists\')}">Music Playlists</a></li> </ul> </div> <div id="no-notifications-subscriptions" if="{opts.subscriptionCount}"> <p class="notifications-long-primer">There will be something here for you soon.</p> <p class="notifications-long-primer">To see what you\'ve already added, go to:</p> <ul class="notifications-long-primer"> <li><a class="notifications-long-primer" href="{this.links.myProgrammes}" onclick="{this.logClickEmptyState(\'iplayer\')}">My Programmes</a></li> <li>|</li> <li><a class="notifications-long-primer" href="{this.links.myArtists}" onclick="{this.logClickEmptyState(\'music-artists\')}">My Artists</a></li> <li>|</li> <li><a class="notifications-long-primer" href="{this.links.myPlaylists}" onclick="{this.logClickEmptyState(\'music-playlists\')}">My Playlists</a></li> </ul> </div> </div> </div> <ul if="{opts.notifications.length}" class="notification-items" aria-live="polite" aria-relevant="additions" aria-atomic="true"> <li class="notification-item notification__item--js {status ? \'notification-\' + status : \'\'}" each="{opts.notifications}"> <a class="notification-item--link" href="{notification.url}" onclick="{this.onLinkClick}" onkeydown="{this.onLinkKeyDown}"> <div class="notification-icon-and-dot notification-{product.toLowerCase()}"> <span class="notification-dot {status ? \'notification-\' + status : \'\'}"></span> <div class="notifications-image notification-{product.toLowerCase()}-icon"> </div> </div> <div class="notification-text {status ? \'notification-\' + status : \'\'}"> <div class="notification-title-items"> <div> <p class="notification-text-body notifications-long-primer">{this.title(notification)}</p> </div> <div class="notification-item--info"> <span class="notification-episode-name notifications-brevier">{this.label(notification.episode, product)}</span> <span class="notification-time notifications-brevier">{sampleWhen ? sampleWhen : this.timeago(creationTimestamp)}</span> </div> </div> </div> </a> </li> </ul> <div class="spinner" if="{opts.loadingMore}"> <img class="loader-icon notifications-image spinner__img--svg" riot-src="{this.parent.basePath + \'/svg/loader.svg\'}" alt="Spinner"> </div> <div class="notifications-keyboard-access" if="{this.showKeyboardAccess}"> <button class="notifications-keyboard-access--btn notifications-keyboard-access--more" onclick="{this.keyboardLoadMore}" __disabled="{opts.reachedEnd}"><i1-8n>Load More</i1-8n></button> <button name="notificationsKeyboardClose" class="notifications-keyboard-access--btn notifications-keyboard-access--close" onclick="{this.closeDrawer}" onkeydown="{this.onKeyboardCloseDown}"><i1-8n>Close</i1-8n></button> </div>', '', '', function(opts) {
'use strict';

var _this = this;

var Utils = require('../utils');
var notificationsAnalytics = require('../analytics');
var config = require('../config');
this.timeago = require('../vendor/timeago');

this.utils = new Utils();
this.links = {
    usingTheBBC: config.env.aroundBBCUrls.usingTheBBC,
    iplayer: config.env.aroundBBCUrls.iplayer,
    musicArtists: config.env.aroundBBCUrls.musicArtists,
    musicPlaylists: config.env.aroundBBCUrls.musicPlaylists,
    myProgrammes: config.env.aroundBBCUrls.myProgrammes,
    myArtists: config.env.aroundBBCUrls.myArtists,
    myPlaylists: config.env.aroundBBCUrls.myPlaylists
};

this.capitalizeFirstLetter = function (str) {
    if (str.toLowerCase() === 'iplayer') {
        return 'iPlayer';
    }

    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

this.closeDrawer = function () {
    document.getElementById('notification-link').click();

    if (document.activeElement) {
        document.querySelector('.orb-nav-news a').focus();
    }
};

this.logClickUpsell = function (type) {
    return function logClick() {
        notificationsAnalytics.log(type, 'notifications-product-upsell');
        return true;
    };
};

this.logClickEmptyState = function (type) {
    return function logClick() {
        notificationsAnalytics.log(type, 'notifications-empty-state');
        return true;
    };
};

this.onLinkClick = function (e) {
    var link = e.item.notification.url;
    var status = _this.getAnalyticsNotificationStatus(e.item.status);
    // Analytics event (notificationsItem click)
    notificationsAnalytics.log('click', 'notifications-item', {
        notifications_id: e.item.id,
        notifications_state: status,
        notifications_priority: (e.item.priority || 'normal').toLowerCase(),
        notifications_product: e.item.product.toLowerCase(),
        notifications_type: e.item.type.toLowerCase(),
        notifications_title: e.item.notification.title,
        topic_name: notificationsAnalytics.serialiseTopic(e.item.topic)
    });

    _this.parent.parent.notificationsModel.markRead(e.item).then(function () {
        window.location.assign(link);
    });

    if (e.preventDefault) {
        e.preventDefault();
    }

    return false;
};

this.getAnalyticsNotificationStatus = function (status) {
    switch (status) {
        case 'new':
            return 'blueDot';
        case 'unread':
            return 'new';
        default:
            return 'read';
    }
};

this.onLinkKeyDown = function (e) {
    if (e.keyCode === 9) {
        // Tab
        var next = document.activeElement.parentNode.nextSibling;
        var endOfList = !(next.classList && next.classList.contains('notification-item'));

        if (endOfList) {
            _this.update({ showKeyboardAccess: true });
        }
    }

    return true;
};

this.onKeyboardCloseDown = function (e) {
    if (e.keyCode === 9 && !e.shiftKey) {
        // Tab
        document.querySelector('.notifications__settings--js').focus();
        return false;
    }

    return true;
};

this.keyboardLoadMore = function () {
    var numNotifications = document.querySelectorAll('.notification-items .notification-item').length;
    console.log('Load more from keyboard', numNotifications);
    _this.parent.parent.fetchNotifications(true).then(function () {
        var next = document.querySelector('.notification-items\n                    .notification-item:nth-child(' + (numNotifications + 1) + ') a');

        console.log('Loaded more from keyboard', next, _this.notificationsKeyboardClose);

        if (next) {
            next.focus();
        } else {
            _this.notificationsKeyboardClose.focus();
        }
    });
};

this.title = function (notification) {
    var dash = '–';
    return notification.title + (notification.episode ? ' ' + dash + ' ' + notification.episode : '');
};

this.label = function (episode, product) {
    return _this.capitalizeFirstLetter(product);
};
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/components/bbc-notifications-list.tag
 ** module id = 23
 ** module chunks = 0
 **/